// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwScrollpanel from 'viewmodel/AwScrollpanelViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import DesSearchFilterCell from 'viewmodel/DesSearchFilterCellViewModel';
    import { ExistWhen } from 'js/hocCollection';
const AwPanelSectionExistWhen = ExistWhen(AwPanelSection);
const DesSearchFilterCellExistWhen = ExistWhen(DesSearchFilterCell);
AwPanelSectionExistWhen.displayName = 'AwPanelSectionExistWhen';
DesSearchFilterCellExistWhen.displayName = 'DesSearchFilterCellExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onUpdate": {
            "action": "setProviderLabel",
            "observers": [
                "props.provider"
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "catalogspaceid": {
            "type": "STRING"
        },
        "provider": {
            "type": "STRING"
        },
        "querystring": {
            "type": "STRING"
        },
        "contentpath": {
            "type": "string"
        },
        "hideelements": {
            "type": "STRING"
        },
        "filterunit": {
            "type": "string"
        }
    },
    "data": {
        "defaultProvider": "SIEMENS",
        "facetsList": [],
        "catalogProviderList": {
            "name": "catalogProviderList",
            "type": "STRING",
            "isRequired": true,
            "dataProvider": "catalogProvider",
            "uiValue": "CADENAS",
            "dbValue": "CADENAS",
            "isSelectOnly": true
        },
        "catalogProviderValues": [
            {
                "propDisplayValue": "CADENAS",
                "propInternalValue": "CADENAS"
            },
            {
                "propDisplayValue": "SIEMENS",
                "propInternalValue": "DES"
            },
            {
                "propDisplayValue": "DIGIKEY",
                "propInternalValue": "DIGIKEY"
            }
        ],
        "providerLabel": {
            "displayName": "{{props.provider || data.defaultProvider}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "{{props.provider || data.defaultProvider}}",
            "labelPosition": "NO_PROPERTY_LABEL",
            "dispValue": "{{props.provider || data.defaultProvider}}"
        },
        "_constants": {
            "PROVIDER": "provider"
        }
    },
    "actions": {
        "setProviderLabel": {
            "actionType": "JSFunction",
            "method": "setProviderLabel",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "events": {
                "success": [
                    {
                        "name": "setProviderLabel.success"
                    }
                ]
            },
            "deps": "js/desSearchService"
        },
        "updateFacetsList": {
            "actionType": "JSFunction",
            "method": "updateFacetsList",
            "inputData": {
                "eventData": "{{parameters.eventData}}",
                "props": "{{props}}"
            },
            "outputData": {
                "facetsList": "facetsList"
            },
            "deps": "js/desSearchService"
        }
    },
    "dataProviders": {
        "catalogProvider": {
            "response": "{{data.catalogProviderValues}}"
        }
    },
    "onEvent": [
        {
            "eventId": "des-catalog-search-result.success",
            "cacheEventData": true,
            "action": "updateFacetsList",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "conditions": {
        "invokeFilterData": {
            "expression": "( props.catalogspaceid && props.querystring && props.querystring.length > 0 )"
        },
        "hideProvider": {
            "expression": "!( props.hideelements && props.hideelements.split(',').indexOf(data._constants.PROVIDER) > -1)"
        }
    },
    "messages": {},
    "i18n": {},
    "_viewModelId": "DesSearchFilter",
    "_uniqueViewModelId": "DesSearchFilter",
    "ctx": {}
};

    /*
    <aw-panel class="h-12">
    <aw-panel-body>
        <aw-flex-row height="fill" width="fill">
            <aw-scrollpanel class="sw-column">
                <aw-panel-section caption="Provider" exist-when="conditions.hideProvider">
                    <aw-label prop="data.providerLabel"></aw-label>
                </aw-panel-section>
                <des-search-filter-cell vmo="data.facetsList" exist-when="data.facetsList.length" class="des-search-filter-cell"></des-search-filter-cell>
            </aw-scrollpanel>
            <!-- <aw-flex-column></aw-flex-column> -->
        </aw-flex-row>
    </aw-panel-body>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="h-12">
        <AwPanelBody>
            <AwFlexRow height="fill" width="fill">
                <AwScrollpanel className="sw-column">
                    <AwPanelSectionExistWhen caption="Provider" existWhen={AwParseService.instance( "conditions.hideProvider" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <AwLabel {...getField("data.providerLabel", fields, $index, null, null )}>
                        </AwLabel>
                    </AwPanelSectionExistWhen>
                    <DesSearchFilterCellExistWhen vmo={AwParseService.instance( "data.facetsList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} className="des-search-filter-cell" existWhen={AwParseService.instance( "data.facetsList.length" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    </DesSearchFilterCellExistWhen>
                </AwScrollpanel>
            </AwFlexRow>
        </AwPanelBody>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;